/**
 * @generated SignedSource<<be8ef7481e3a50bef0ced6c107424e12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type answersStatisticsTable_Query$variables = {
  filterByTagIds?: ReadonlyArray<string> | null | undefined;
  filterByTitle?: string | null | undefined;
  greaterThanDate?: string | null | undefined;
  lessThanDate?: string | null | undefined;
};
export type answersStatisticsTable_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"answersStatisticsTable_Fragment">;
};
export type answersStatisticsTable_Query = {
  response: answersStatisticsTable_Query$data;
  variables: answersStatisticsTable_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByTagIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByTitle"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "greaterThanDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lessThanDate"
},
v4 = {
  "kind": "Variable",
  "name": "filterByTagIds",
  "variableName": "filterByTagIds"
},
v5 = {
  "kind": "Variable",
  "name": "filterByTitle",
  "variableName": "filterByTitle"
},
v6 = {
  "kind": "Variable",
  "name": "greaterThanDate",
  "variableName": "greaterThanDate"
},
v7 = {
  "kind": "Variable",
  "name": "lessThanDate",
  "variableName": "lessThanDate"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "answersStatisticsTable_Query",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "answersStatisticsTable_Fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "answersStatisticsTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StatisticAdminSchema",
            "kind": "LinkedField",
            "name": "Statistic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "NodeQuestionAndAnswersTriesConnection",
                "kind": "LinkedField",
                "name": "AnswersStatistic",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NodeQuestionAndAnswersTriesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NodeQuestionAndAnswersTries",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootNodeId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootNodeTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementStatistics",
                            "kind": "LinkedField",
                            "name": "elementStatistics",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "elementId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalTries",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "correctPercentage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerStatistics",
                                "kind": "LinkedField",
                                "name": "answerStatistics",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "checkedTimes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "index",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCorrect",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "filterByTitle",
                  "greaterThanDate",
                  "lessThanDate",
                  "filterByTagIds"
                ],
                "handle": "connection",
                "key": "answersStatisticsTable_AnswersStatistic",
                "kind": "LinkedHandle",
                "name": "AnswersStatistic"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b9335da5687ce3f7edcf65b7a21773f",
    "id": null,
    "metadata": {},
    "name": "answersStatisticsTable_Query",
    "operationKind": "query",
    "text": "query answersStatisticsTable_Query(\n  $filterByTitle: String\n  $greaterThanDate: ZonedDateTIme\n  $lessThanDate: ZonedDateTIme\n  $filterByTagIds: [ID!]\n) {\n  ...answersStatisticsTable_Fragment_2hPXjC\n}\n\nfragment answersStatisticsTable_Fragment_2hPXjC on Query {\n  Admin {\n    Statistic {\n      AnswersStatistic(first: 1, filterByTitle: $filterByTitle, greaterThanDate: $greaterThanDate, lessThanDate: $lessThanDate, filterByTagIds: $filterByTagIds) {\n        edges {\n          node {\n            rootNodeId\n            rootNodeTitle\n            elementStatistics {\n              elementId\n              question\n              totalTries\n              correctPercentage\n              answerStatistics {\n                checkedTimes\n                index\n                isCorrect\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1729cb3adb3061e2ff98144015d41fe9";

export default node;
